import { render, staticRenderFns } from "./CaseImageUpload.vue?vue&type=template&id=cb1db6b6&scoped=true"
import script from "./CaseImageUpload.vue?vue&type=script&lang=js"
export * from "./CaseImageUpload.vue?vue&type=script&lang=js"
import style0 from "./CaseImageUpload.vue?vue&type=style&index=0&id=cb1db6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1db6b6",
  null
  
)

export default component.exports